<template>
  <transition name="fade" mode="in-out">
    <div class="modal--mask" :class="{foreground: foreground}">
      <div class="modal--wrapper">
        <div class="modal--container" :class="{'modal--list': isList}">
          <div class="modal--header" :class="{'modal--list': isList}">
            <slot name="header">
              <div class="btn-close" v-if="closeButton" @click="$emit('close')">
                <img src="../assets/images/close.svg">
              </div>
            </slot>
          </div>
          <div class="modal--body" :class="{'modal--list': isList}">
            <slot name="body">

            </slot>
          </div>
          <div class="modal--footer">
            <slot name="footer">

            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<style>
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
<script>
export default {
  name: 'Modal',
  props: {
    foreground : {
      type: Boolean,
      default: false
    },
    isList : {
      type: Boolean,
      default: false
    },
    closeButton : {
      type: Boolean,
      default: true
    }
  },
  mounted(){
    document.body.classList.add('modal-open')
  },
  destroyed(){
    document.body.classList.remove('modal-open')
  },
  created(){
    
    
  }
}
</script>
